import { startAuthentication, startRegistration } from '@simplewebauthn/browser';

import {
	mapToWebAuthnClientError,
	type WebAuthnAuthenticationAssertion,
	type WebAuthnAuthenticationOptions,
	type WebAuthnClientRepository,
	type WebAuthnRegistrationCredential,
	type WebAuthnRegistrationOptions
} from '@contexts/shared/domain';

export function simpleWebAuthnClientRepositoryBuilder(): WebAuthnClientRepository {
	return {
		async registerPasskey(
			input: WebAuthnRegistrationOptions
		): Promise<WebAuthnRegistrationCredential> {
			try {
				return await startRegistration(input);
			} catch (cause) {
				throw mapToWebAuthnClientError(cause, 'register');
			}
		},

		async authenticatePasskey(
			input: WebAuthnAuthenticationOptions
		): Promise<WebAuthnAuthenticationAssertion> {
			try {
				return await startAuthentication(input);
			} catch (cause) {
				throw mapToWebAuthnClientError(cause, 'authenticate');
			}
		}
	};
}
